import { on } from '@ember/modifier';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { Dayjs } from 'dayjs';
import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';
import dateRangeDisplay from 'lumen/utils/dates/date-range-display';

interface HotelAndMarketRevenueInsightDropdownsTriggersTriggerTargetSignature {
  Args: {
    extra: {
      isNetComparison: boolean;
    };
    isOpen: boolean;
    label?: string;
    selected:
      | string
      | {
          end: Dayjs;
          start: Dayjs;
        };
    toggleDropdown: () => void;
  };
}

export default class HotelAndMarketRevenueInsightDropdownsTriggersTriggerTarget extends Component<HotelAndMarketRevenueInsightDropdownsTriggersTriggerTargetSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedSelected() {
    if (
      typeof this.args.selected === 'object' &&
      'start' in this.args.selected
    ) {
      return dateRangeDisplay(
        this.args.selected.start,
        this.args.selected.end,
        this.intl,
      );
    }

    return this.intl.t(this.args.selected);
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div
      class="select-wrapper left-column prism-dropdown-trigger picker month-selection-trigger
        {{if @isOpen 'open'}}
        {{if @label 'has-label'}}"
      data-event-id="datepicker-toggle-dropdown"
      data-event-value={{not @isOpen}}
      data-test-id="target-picker-trigger"
      role="button"
      {{on "click" @toggleDropdown}}
    >
      <div class="trigger__content gap-100">
        <span>
          {{t "revenue_insight.vs"}}
          {{#if @extra.isNetComparison}}
            {{t "revenue_insight.net"}}
          {{/if}}

          {{this.formattedSelected}}
        </span>
        <PrismIcon
          @name={{if @isOpen "chevron-up" "chevron-down"}}
          @size="small"
        />
      </div>
    </div>
  </template>
}
